import React, { useEffect, useState, useCallback } from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import {
  getGoal,
  getSuccessors,
  updateGoal,
} from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import './SetGoal.css';
import lodash from 'lodash';
import { CommonButton } from '../../../Components/CommonComponents';
import { messages } from '../../../utils/constant-messages';
import { useNavigate } from 'react-router-dom';
import Storage from '../../../services/Storage';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { handleErrorMessage } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
export const SetGoal = () => {
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();

  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;

  useEffect(() => {
    if (!localPermission.includes(Permissions.SET_GOAL)) {
      navigate('/');
    }
  }, [...localPermission])

  const monthArr = [
    { id: 1, monthName: 'January' },
    { id: 2, monthName: 'February' },
    { id: 3, monthName: 'March' },
    { id: 4, monthName: 'April' },
    { id: 5, monthName: 'May' },
    { id: 6, monthName: 'June' },
    { id: 7, monthName: 'July' },
    { id: 8, monthName: 'August' },
    { id: 9, monthName: 'September' },
    { id: 10, monthName: 'October' },
    { id: 11, monthName: 'November' },
    { id: 12, monthName: 'December' },
  ];

  const yearArr = [
    { id: new Date().getFullYear(), yearName: new Date().getFullYear() },
    {
      id: new Date().getFullYear() + 1,
      yearName: new Date().getFullYear() + 1,
    },
    {
      id: new Date().getFullYear() + 2,
      yearName: new Date().getFullYear() + 2,
    },
    {
      id: new Date().getFullYear() + 3,
      yearName: new Date().getFullYear() + 3,
    },
    {
      id: new Date().getFullYear() + 4,
      yearName: new Date().getFullYear() + 4,
    },
    {
      id: new Date().getFullYear() + 5,
      yearName: new Date().getFullYear() + 5,
    },
    {
      id: new Date().getFullYear() + 6,
      yearName: new Date().getFullYear() + 6,
    },
    {
      id: new Date().getFullYear() + 7,
      yearName: new Date().getFullYear() + 7,
    },
    {
      id: new Date().getFullYear() + 8,
      yearName: new Date().getFullYear() + 8,
    },
    {
      id: new Date().getFullYear() + 9,
      yearName: new Date().getFullYear() + 9,
    },
    {
      id: new Date().getFullYear() + 10,
      yearName: new Date().getFullYear() + 10,
    },
  ];

  const [isLoading, setIsloading] = useState(false);
  const [userQuery, setUserQuery] = useState('');

  const [monthId, setMonthId] = useState(new Date().getMonth() + 1);
  const [yearId, setYearId] = useState(new Date().getFullYear());

  const [goalArr, setGoalArr] = useState([]);

  const [prUser, setPruser] = useState([]);
  const [prUserId, setPruserId] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  useEffect(() => {
    setIsloading(true);
    getGoalData();
  }, [searchQuery, prUserId, monthId, yearId]);

  const getGoalData = () => {
    let payload = {
      query: searchQuery,
      userId: prUserId ? prUserId : 0,
      month: monthId,
      year: yearId,
    };
    getGoal((res) => {
      let { data, success, error } = res;
      if (success === true) {
        setGoalArr(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  };

  const handleChangeGoal = (e, uuid) => {
    if (uuid) {
      let index = goalArr.findIndex((elem) => elem.uuid === uuid);
      goalArr[index].goal = e.target.value;
      setGoalArr([...goalArr]);
    }
  };

  useEffect(() => {
    setIsloading(true);
    getAllUsers();
  }, []);

  const getAllUsers = () => {
    getSuccessors((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setIsloading(false);
        setPruser(data);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    });
  };

  const handleChangePruser = (e) => {
    let val = e.target.value;
    setPruserId(val);
    setIsloading(true);
  };

  let tmUser = prUser.filter((elem) => elem.role === Roles.TM_NAME);
  let shUser = prUser.filter((elem) => elem.role === Roles.SH_NAME);
  let nhUser = prUser.filter((elem) => elem.role === Roles.NH_NAME);
  let bhUser = prUser.filter((elem) => elem.role === Roles.BH_NAME);

  const updateGoalValue = (elem) => {
    let payload = {
      uuid: elem.uuid,
      goal: elem.goal ? parseFloat(elem.goal).toFixed(3) : '',
    };
    updateGoal((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        getGoalData();
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  };

  const handleSearchChange = (e) => {
    let q = e.target.value;
    setUserQuery(q);
    delayedQuery(q);
  };
  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='setGoal'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Set Goal' />
                      </div>
                    </Col>
                  </Row>
                  <div className='filterArea'>
                    <Row>
                      <Col xs={12}>
                        <div className='d-flex flex-wrap align-items-center justify-content-between'>
                          <div className='filterWrapper d-flex flex-wrap align-items-center'>
                            <div className='filterDropdown filterInput'>
                              <label htmlFor='selectMonth'>Month:</label>
                              <br />
                              <select
                                name='selectMonth'
                                id='selectMonth'
                                value={monthId}
                                onChange={(e) => {
                                  setIsloading(true);
                                  setMonthId(e.target.value);
                                }}
                              >
                                {/* <option value={''}>All</option> */}
                                {monthArr.length > 0 &&
                                  monthArr.map((elem, index) => {
                                    const { id, monthName } = elem;
                                    return (
                                      <option value={id} key={index}>
                                        {monthName}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                            <div className='filterDropdown filterInput'>
                              <label htmlFor='selectYear'>Year:</label>
                              <br />
                              <select
                                name='selectYear'
                                id='selectYear'
                                value={yearId}
                                onChange={(e) => {
                                  setIsloading(true);
                                  setYearId(e.target.value);
                                }}
                              >
                                {/* <option value={''}>All</option> */}
                                {yearArr.length > 0 &&
                                  yearArr.map((elem, index) => {
                                    const { id, yearName } = elem;
                                    return (
                                      <option value={id} key={index}>
                                        {yearName}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                            <div className='filterDropdown filterInput'>
                              <div className='userSelect'>
                                <label htmlFor='userLabel'>Select User:</label>
                                <br />
                                <select
                                  className='selectpicker'
                                  value={prUserId}
                                  onChange={(e) => handleChangePruser(e)}
                                >
                                  <option value={0}>All</option>
                                  {bhUser.length > 0 && roleName !== Roles.BH_NAME && (
                                    <optgroup label='Business Head'>
                                      {bhUser[0].users.map((elem, index) => {
                                        return (
                                          <option value={elem.id} key={index}>
                                            {elem.first_name} {elem.last_name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                  )}
                                  {nhUser.length > 0 && roleName !== Roles.NH_NAME && (
                                    <optgroup label='National Head'>
                                      {nhUser[0].users.map((elem, index) => {
                                        return (
                                          <option value={elem.id} key={index}>
                                            {elem.first_name} {elem.last_name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                  )}
                                  {shUser.length > 0 && roleName !== Roles.SH_NAME && (
                                    <optgroup label='State Head'>
                                      {shUser[0].users.map((elem, index) => {
                                        return (
                                          <option value={elem.id} key={index}>
                                            {elem.first_name} {elem.last_name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                  )}
                                  {tmUser.length > 0 && roleName !== Roles.TM_NAME && (
                                    <optgroup label='Territory Manager'>
                                      {tmUser[0].users.map((elem, index) => {
                                        return (
                                          <option value={elem.id} key={index}>
                                            {elem.first_name} {elem.last_name}
                                          </option>
                                        );
                                      })}
                                    </optgroup>
                                  )}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className='serachWrapper filterInput'>
                            <label htmlFor='search'>&nbsp;</label>
                            <br />
                            <input
                              name='search'
                              autoComplete='off'
                              type='text'
                              placeholder='Search'
                              id='search'
                              onChange={handleSearchChange}
                              value={userQuery}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {goalArr.length ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-left'>
                            <thead>
                              <tr>
                                <th>User Name</th>
                                <th>Product Name</th>
                                <th>Goal</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {goalArr.map((elem, index) => {
                                const {
                                  goal,
                                  uuid,
                                  first_name,
                                  last_name,
                                  type,
                                  unit_type,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>
                                      {first_name} {last_name}
                                    </td>
                                    <td>{type}</td>
                                    <td>
                                      <div className='d-flex flex-wrap align-items-center'>
                                        <input
                                          className='common-input mr-2'
                                          value={
                                            elem.goal ? elem.goal : ''
                                          }
                                          type='text'
                                          required
                                          onKeyPress={(e) => {

                                            let regex = /^[0-9.\b]+$/;
                                            if (!regex.test(e.key)) {
                                              e.preventDefault();
                                            }
                                            let splitDot = e.target.value && e.target.value.includes('.') ? e.target.value.split('.') : [];
                                            if (splitDot.length > 1 && e.key === '.') { // only 1 dot
                                              e.preventDefault();
                                            }

                                            if (splitDot && splitDot.length > 1 && splitDot[1].length > 2) {
                                              e.preventDefault();
                                            }

                                          }}
                                          autoComplete='off'
                                          onChange={(e) => handleChangeGoal(e, uuid)}
                                          placeholder='Type Here'
                                          name={`goal${uuid}`}
                                        />
                                        <span>{unit_type}</span>
                                      </div>
                                    </td>
                                    <td>
                                      {goal ? (
                                        <CommonButton name={'Update'} maxWidth="80px" btnClass={'btnPrimary updateBtn'} type="button" onClick={() => updateGoalValue(elem)} />
                                      ) : (
                                        ''
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
            </div >
          </div>
        </div>
      </div>
    </>
  );
};
